import React from 'react';
import { Container, Segment, Grid, Image, Header, Divider } from 'semantic-ui-react';

const Home = () => (
	<Segment basic>
		<Container>
			<Grid stackable>
				<Grid.Row>
					<Grid.Column width={10}>
						<Image src='/assets/images/roselandlogo.jpg' centered/>
					</Grid.Column>
					<Grid.Column width={6} verticalAlign="middle">
						<Header content="Welcome to the Roseland Institute" as="h1"/>
						<Header content="Director:" /> 
						<p>James C.A. Whetter B.A., Ph.D.</p>
						<Header content="Assistant Directors:" />
						<p>Talwyn V. Whetter B.A., M.Sc.</p>
						<p>Esyld M. Mason B.Sc.</p>
					</Grid.Column>
				</Grid.Row>
				<Divider />
				<Grid.Row divided>
					<Grid.Column width={8}>
						<Header as="h1" content="Centre for Cornish Studies" />
						<p>The Institute contains a library of over 20,000 books in the process of being catalogued and put on-line.</p>
						<p>It is the base for the publishing activities of Lyfrow Trelyspen and CNP Publications. The former produces works on Cornish history, essays and related subjects. The latter, the quarterly Cornish magazine, The Cornish Banner \ An Baner Kernewek.</p>
						<p>It has a "Rowse Room" with books and memorabilia relating to the historian and poet, A. L. Rowse, 80 publications of his are held by the Institute and 2500 books from his library, all of which have been catalogued.</p>
						<p>There is also a collection of works and memorabilia of the Gorran-born writer Anne Treneer.</p>
						<p>The Institute is set in an attractive coastal position with views of the Channel and the cliffs around Gorran Haven.</p>
					</Grid.Column>
					<Grid.Column width={8} textAlign="center" verticalAlign="middle">
						<Image src='/assets/images/dr-james-whetter.jpg' centered/>
						<strong>Dr James Whetter at St. Michael's Mount</strong>
					</Grid.Column>
				</Grid.Row>
			</Grid>
		</Container>
	</Segment>
)

export default Home;


// WEBPACK FOOTER //
// ./src/components/Home.js